import { render, staticRenderFns } from "./VideoStitching.vue?vue&type=template&id=b0324ce2&scoped=true"
import script from "./VideoStitching.vue?vue&type=script&lang=js"
export * from "./VideoStitching.vue?vue&type=script&lang=js"
import style0 from "./VideoStitching.vue?vue&type=style&index=0&id=b0324ce2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0324ce2",
  null
  
)

export default component.exports